import { apiFetch } from '@lib/api/apiClient';

export async function registerInquiry(formData) {
    const res = await apiFetch('/inquiry/register', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    });

    if (!res.ok) {
        throw new Error('1:1문의 정보 저장에 실패하였습니다.');
    }
    return (await res.json()).data;
}

export async function modifyInquiry(formData) {
    const res = await apiFetch('/inquiry/modify', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    });
    if (!res.ok) {
        throw new Error('1:1문의 정보 수정에 실패하였습니다.');
    }
    return (await res.json()).data;
}

/**
 * @param {any} searchParam
 */
export async function getInquiry(searchParam) {
    const res = await apiFetch(`/inquiry/list`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(searchParam)
    });

    if (!res.ok) {
        throw new Error('1:1문의 목록을 불러오지 못했습니다.');
    }

    return (await res.json()).data;
}